import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles((theme) => ({
  title: {
    display: 'none',
  },
  paper: {
    height: '100%',
    background: theme.palette.background.paper,
  },
  tabsRoot: {
    borderBottom: 'none',
  },
  tabsRoot2: {
    justifyContent: 'center',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
    display: 'none',
  },
  tabsIndicator2: {
    backgroundColor: variables.palette.primary.main,
  },
  tabRoot: {
    fontWeight: 400,
    borderBottom: '1px solid #ccc',
    padding: 8,
    '&:hover': {
      color: variables.palette.primary.dark,
      opacity: 1,
    },
    '&$tabSelected': {
      color: variables.palette.primary.main,
      fontWeight: 500,
      background: 'rgba(0,0,0,0.1)',
    },
    '&:focus': {
      color: variables.palette.primary.dark,
    },
    '& .title-section': {
      lineHeight: 1.35,
    },
  },
  tabRoot2: {
    minWidth: 72,
    borderBottom: '1px solid #e8e8e8',
    '&$tabSelected': {
      color: variables.palette.primary.main,
      fontWeight: 500,
    },
  },
  tabSelected: {},
  tab: {
    marginBottom: 8,
    width: '100%',
  },
  typography: {
    padding: theme.spacing(2) * 3,
  },
  lineGraphNav: {
    borderBottom: '1px solid #e8e8e8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  lineGrap: {
    height: 300,
    padding: 16,
    [theme.breakpoints.down('sm')]: {
      height: 400,
    },
  },
  smallCard: {},
  cardHead: {
    padding: 16,
    paddingLeft: 24,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTab: {},
  cardContent: {},
  cardGraph: {
    height: 220,
    paddingTop: 24,
  },
  cardLegends: {
    padding: 24,
    paddingTop: 8,
  },
  legendsList: {
    marginBottom: 4,
    fontSize: 14,
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  iframe: {
    width: '100%',
    border: 'none',
    height: 125,
    marginBottom: 12,
    '@media screen and (max-width: 640px)': {
      height: 265,
    },
  },
  gridWallet: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  walletContainer: {
    flexGrow: 1,
  },
}));
